import classNames from "classnames";
import React from "react";

interface ModuleContainerProps {
    title: string;
    size?: number;
}

export class ModuleContainer extends React.Component<ModuleContainerProps, {}> {
    render() {
        return (
            <div className="module-container" style={{ display: "flex", justifyContent: 'center', alignItems: "center", flexDirection: 'column' }}>
                <div className="module-container-title">{this.props.title}</div>
                <div className="module-container-items">
                    <div className={classNames("block-container")} style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: "100%", gap: '1rem' }}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
